import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import transparentImage from '../../assets/transparent-min.png';
function encodeParams(params) {
  return Object.keys(params).map(key => [key, params[key]].map(encodeURIComponent).join('=')).join('&');
}
const ContentfulImage = t0 => {
  const $ = _c(16);
  const {
    src,
    alt,
    type,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let sizes;
  let srcSet;
  let t2;
  let t3;
  if ($[0] !== src || $[1] !== type) {
    let widths;
    let imageParams;
    bb0: switch (type) {
      case "grid":
        {
          sizes = "(max-width: 599px) 100vw, 50vw";
          imageParams = {
            w: 900,
            fit: "fill",
            fl: "progressive",
            h: 338
          };
          widths = [300, 400, 500, 600, 700, 800, 900, 1000, 1100];
          srcSet = [];
          widths.forEach((width_2, i_0) => {
            const srcParams_2 = {
              ...imageParams,
              w: widths[i_0],
              h: Math.round(widths[i_0] * 0.5625)
            };
            srcSet.push(`${src}?${encodeParams(srcParams_2)} ${width_2}w`);
          });
          srcSet = srcSet.join(", ");
          break bb0;
        }
      case "hero":
        {
          sizes = "(max-width: 1380px) 100vw, 1380px";
          imageParams = {
            h: 720,
            w: 1920,
            fit: "fill",
            fl: "progressive"
          };
          widths = [1366, 1600, 1920, 2000, 2300];
          srcSet = [];
          widths.forEach(width_1 => {
            const srcParams_1 = {
              ...imageParams,
              w: width_1,
              h: Math.round(width_1 * 0.375)
            };
            srcSet.push(`${src}?${encodeParams(srcParams_1)} ${width_1}w`);
          });
          srcSet = srcSet.join(", ");
          break bb0;
        }
      case "featured":
        {
          sizes = "(max-width: 767px) 100vw, 70vw";
          imageParams = {
            w: 1600,
            h: 1063,
            fit: "fill",
            fl: "progressive"
          };
          widths = [768, 1024, 1366, 1600, 1920];
          srcSet = [];
          widths.forEach(width_0 => {
            const srcParams_0 = {
              ...imageParams,
              w: width_0,
              h: Math.round(width_0 * 0.664375)
            };
            srcSet.push(`${src}?${encodeParams(srcParams_0)} ${width_0}w`);
          });
          srcSet = srcSet.join(", ");
          break bb0;
        }
      case "blogProduct":
        {
          sizes = "(max-width: 650px) 100vw, 650px";
          imageParams = {
            w: 900,
            fit: "fill",
            fl: "progressive"
          };
          widths = [300, 400, 500, 600, 700, 800, 900, 1000, 1100];
          srcSet = [];
          widths.forEach((width, i) => {
            const srcParams = {
              ...imageParams,
              w: widths[i]
            };
            srcSet.push(`${src}?${encodeParams(srcParams)} ${width}w`);
          });
          srcSet = srcSet.join(", ");
          break bb0;
        }
      default:
    }
    t2 = src;
    t3 = encodeParams(imageParams);
    $[0] = src;
    $[1] = type;
    $[2] = sizes;
    $[3] = srcSet;
    $[4] = t2;
    $[5] = t3;
  } else {
    sizes = $[2];
    srcSet = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const publicSrc = `${t2}?${t3}`;
  const loading = type === "hero" || type === "featured" ? "eager" : "lazy";
  const t4 = isNewConsumerApp ? publicSrc : transparentImage;
  const t5 = !isNewConsumerApp ? `lazyload ${className}` : className;
  let t6;
  if ($[6] !== loading || $[7] !== publicSrc || $[8] !== sizes || $[9] !== srcSet) {
    t6 = isNewConsumerApp ? {
      srcSet,
      sizes,
      loading
    } : {
      "data-sizes": sizes,
      "data-src": publicSrc,
      "data-srcset": srcSet
    };
    $[6] = loading;
    $[7] = publicSrc;
    $[8] = sizes;
    $[9] = srcSet;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== alt || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <img src={t4} alt={alt} className={t5} {...t6} />;
    $[11] = alt;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
ContentfulImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string
};
export default ContentfulImage;